module.exports = __webpack_public_path__ + "static/img/qijiantao.b2eeb6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/srzq/qijiantao.jpg
// module id = +HJ4
// module chunks = 0